import { Row, Form, Input, Switch, FormInstance } from "antd";
import { useCallback } from "react";
import { useFormHandlers } from "./hooks/formHandlers/editAddHandlers";
import { Footer } from "./Footer";
import { useFormRules } from "./hooks/useFormRules";
import { useDeleteHandler } from "./hooks/formHandlers/deleteHandler";

type BankAccountFormProps = {
  selectedItem: any;
  isPrimaryDisabled: boolean;
  showAddAndNewButton: boolean;
  customerId: string;
  reload: () => void;
  close: () => void;
};

export const BankAccountForm = ({
  selectedItem,
  customerId,
  showAddAndNewButton,
  reload,
  close,
  isPrimaryDisabled,
}: BankAccountFormProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { bankAccountNumberRules, bankTransitRules } = useFormRules();

  const reloadOnSaved = useCallback(() => {
    reload();
    close();
  }, [reload, close]);

  const { onAddClicked, isFormDisabled, setIsFormDisabled } = useFormHandlers(
    form,
    customerId,
    selectedItem,
    reloadOnSaved,
    reload,
  );

  const { onRemoveClicked } = useDeleteHandler();

  const removeClickHandler = useCallback(
    () => onRemoveClicked(selectedItem.id, setIsFormDisabled, reloadOnSaved),
    [onRemoveClicked, reloadOnSaved, selectedItem, setIsFormDisabled],
  );

  return (
    <>
      <Row className="py-8 px-6 d-block sidebar-body bank-account-form  user-content">
        <Form
          form={form}
          autoComplete="off"
          layout="vertical"
          className="w-100"
          requiredMark={false}
          disabled={isFormDisabled}
          initialValues={selectedItem}
        >
          <Row className="mb-4 w-100">
            <Form.Item
              className="mb-0 w-100"
              name="bankAccountNumber"
              label="Bank Account Number"
              rules={bankAccountNumberRules}
            >
              <Input />
            </Form.Item>
          </Row>
          <Row className="mb-4 w-100">
            <Form.Item
              className="mb-0 w-100"
              name="bankTransitRouting"
              label="Bank Transit/Routing"
              rules={bankTransitRules}
            >
              <Input />
            </Form.Item>
          </Row>
          <Row className="mb-4 w-100">
            <Form.Item
              className="mb-0 w-100"
              name="isPrimary"
              label="Primary"
              valuePropName="checked"
            >
              <Switch disabled={isPrimaryDisabled || isFormDisabled} />
            </Form.Item>
          </Row>
        </Form>
      </Row>
      <Footer
        selectedItem={selectedItem}
        isFormDisabled={isFormDisabled}
        showAddAndNewButton={showAddAndNewButton}
        close={close}
        onAddClicked={onAddClicked}
        onRemove={removeClickHandler}
      />
    </>
  );
};
